module.exports = __webpack_public_path__ + "assets/media/ASimplifiedCanteen.f415658b.mp4";